import React from "react";
import { Link } from "react-router-dom";
import "./blog.css";

const Stanford = () => {
  return (
    <div className="blog">
      <div className="container">
        <div className="content">
          <Link to="/writings" className="back-link">
            ← back to writings
          </Link>
          <div className="blog-header-row">
            <div className="flex gap-4 items-center flex-row">
              <h1>a stanford essay i liked</h1>
            </div>
            <p className="blog-date">2026-01-05</p>
          </div>
          <div className="border-b border-gray-400 text-gray-700 py-2">
            you have no original thoughts :DD
          </div>
          <div className="blog-content">
            <div className="blog-body">
              <p>
                As the last note of our favorite K-Drama piece faded from my flute, the impulse to celebrate my first successful performance for my mother gave way to an uneasy question: was I really a musician or just someone following instructions?
              </p>

              <p>
                Yes, my Hotel del Luna-obsessed mom recognized the somber tune. But throughout my self-taught journey to make up for my vocal shortcomings, my mission had solely been to hear our beloved melody. For months, I'd mechanically worked to memorize the notes, one by one.
              </p>

              <p>
                That spiral introduced me to my first thought experiment: John Searle's Chinese Room. A man follows instructions to produce Chinese responses. To outside observers, he understands Chinese. But does he? I realized my question—if tapping the buttons on my flute indicated that I was a musician—was just a spin on a decades-old hypothetical created to prove a point about computers.
              </p>

              <p>
                Humbled, I followed the thread: Searle had echoed Turing's 1950 imitation game, which itself had been rooted in Descartes' 1637 doubt about automata mimicking language. It seemed that even the most abstract personal questions had remnants in a hypothetical speculated centuries before. Perhaps even Schrodinger—contemplating quantum superpositions—was beaten to the punch by the Neanderthals, wondering if back home inside of their cave the fire truly went out.
              </p>

              <p>
                At Stanford, continuing my fascination with thought experiments—especially those on the conscious mind—I'll take classes like Minds and Machines and Theories of Consciousness. Hopefully, years down the line, another Stanford student will notice Lee simply expanded upon Searle.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stanford;
